import {
  commitMutation,
  graphql
} from 'react-relay';

import environment from '../Environment';

const mutation = graphql`
mutation ResetPasswordRequestMutation($email: String!) {
  resetPasswordRequest(email: $email) {
    ok
    error
  }
}
`;

export default ({ email }, done) => {
  const variables = {
    email
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      onCompleted: (response) => {
        const { ok, error } = response.resetPasswordRequest;
        done(ok, error);
      },
      onError: err => console.error(err)
    }
  );
};
